import { api } from '..';

import { fetchVehicleConsultUrl } from './constants';
import { VehicleConsultResponse } from './types';

export const fetchVehicleConsultService = async (plate: string) => {
  return await api
    .get<VehicleConsultResponse>(`${fetchVehicleConsultUrl}?plate=${plate}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch(() => {
      return Promise.reject([]);
    });
}